import { Injectable, NgZone } from '@angular/core';
import * as appboy from '@braze/web-sdk';
import { BrazeService } from './braze.service';
import { AnalyticsService } from 'src/smoothr-web-app-core/services/analytics/analytics.service';
import { RepositoryService } from '../../smoothr-web-app-core/services/repository/repository.service';

declare var Cookiebot: any;

@Injectable({
	providedIn: 'root',
})
export class CookieConsentService {
	static marketing = false;
	constructor(
		private ngZone: NgZone,
		private brazeService: BrazeService,
		private analyticsService: AnalyticsService,
		private repoService: RepositoryService
	) {}

	public initializeCookieConsent() {
		this.ngZone.run(() => {
			window.addEventListener('CookiebotOnLoad', () => this.handleConsent());
		});
	}

	private async handleConsent() {
		const consent = window['CookieConsent'].consent;
		if (consent) {
			if (consent.marketing) {
				// this.startBrazeInitialize();
				CookieConsentService.marketing = true;
				await this.setAnalyticsEnabled(true);

				if (!appboy.isInitialized()) this.brazeService.initializeService();
				if (!this.repoService?._customerAuth?.customer?.isAnonymous || this.repoService.orders.value.length)
					this.brazeService.initUser(this.repoService._customerAuth);
			} else {
				await this.setAnalyticsEnabled(false);
				this.brazeService.disableSdk();
			}
			// if (consent.marketing) {
			// 	this.enableMarketing();
			// } else {
			// 	this.disableMarketing();
			// }
		}
	}

	// private enableMarketing() {
	// 	this.startBrazeInitialize();
	// }
	//
	// private disableMarketing() {
	// 	this.brazeService.disableSdk();
	// }

	private async startBrazeInitialize() {
		this.brazeService.initializeService();
		this.brazeService.requestPushPermission();
	}

	async setAnalyticsEnabled(enabled: boolean) {
		await this.analyticsService.setAnalyticsCollectionEnabled(enabled);
	}
}
